import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tooltip,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useMutateAutoNumberingHandler } from '../dataHandlers/mutateAutoNumberingHandler';
import { fetchOrgRequest } from '../../../api/organizations/orgSlice';

const AutoNumberSettingSection = () => {
  const dispatch = useDispatch();
  const { settings } = useSelector((state) => state.org.org);

  const onSuccess = () => {
    dispatch(fetchOrgRequest());
  };

  const { onSubmit } = useMutateAutoNumberingHandler({ onSuccess });

  const handleSubmit = async (updatedAutoNumberGen) => {
    await onSubmit({ auto_numbering_enabled: updatedAutoNumberGen });
  };

  return (
    <Paper elevation={0} sx={{ pl: '1rem' }}>
      <Grid container>
        <Grid size={6}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Switch
                  checked={settings?.auto_numbering_enabled}
                  onChange={() => {
                    handleSubmit(!settings?.auto_numbering_enabled);
                  }}
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {"Auto-generate document numbers"}
                  <Tooltip title={"Automatically create sequential document numbers for new invoices and credit notes."}>
                    <IconButton size="small">
                      <InfoOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              }
              labelPlacement="start"
              sx={{ ml: 0, justifyContent: 'space-between', width: '100%' }}
            />
          </FormGroup>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AutoNumberSettingSection;
